/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-up-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 10 19.1',
    data: '<g><path pid="0" d="M7.9 13.4L5 16.3l-2.9-2.9c-.5-.5-1.3-.5-1.7 0-.5.5-.5 1.3 0 1.7L4 18.7c.6.6 1.5.6 2.1 0l3.6-3.6c.5-.5.5-1.3 0-1.7-.5-.5-1.3-.5-1.8 0z"/><path pid="1" d="M2.1 5.8l2.9-3 2.9 2.9c.5.5 1.3.5 1.7 0 .5-.5.5-1.3 0-1.7L6.1.4C5.5-.2 4.6-.2 4 .4L.4 4c-.5.5-.5 1.3 0 1.7.4.5 1.2.5 1.7.1z"/></g>'
  }
})
